import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { ChipAutocompleteFormComponent } from "./chip-autocomplete-form/chip-autocomplete-form.component";
import { TypeFilterComponent, TypeFilterOptionComponent } from "./type-filter/type-filter.component";
import { RouterComponent } from "./type-router-filter/router.component";
import { BadgeModule } from "../badge/badge.module";
import { ButtonModule } from "../button/button.module";
import { IconModule } from "../icon/icon.module";
import { InputModule } from "../input";

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		ButtonModule,
		RouterModule,
		InputModule,
		ReactiveFormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" }),
		BadgeModule,
		IconModule,
	],
	declarations: [TypeFilterComponent, TypeFilterOptionComponent, RouterComponent, ChipAutocompleteFormComponent],
	exports: [TypeFilterComponent, TypeFilterOptionComponent, RouterComponent, ChipAutocompleteFormComponent],
})
export class FilterModule {}
